import { Size } from '@ff-os/shared-utils/types/Size';
import { PhotoPrintsJson } from './PhotoPrintsJson';
import { getRotationSettings } from './rotationSettings';

export const toSpaces = (size: Size, photo: PhotoPrintsJson.ProcessedPhoto) => {

    const settings = getRotationSettings(size, photo);

    const width = settings.rotateScene ? size.height : size.width;
    const height = settings.rotateScene ? size.width : size.height;

    return {

        sceneWidth: width,
        sceneHeight: height,

        designAreaX: 0,
        designAreaY: 0,
        designAreaWidth: photo.crop.width,
        designAreaHeight: photo.crop.height,

        designWidth: photo.crop.width,
        designHeight: photo.crop.height
    };
};